import crypto from "crypto";
import seedrandom from "seedrandom";
const stringify = (data) => {
  if (data == null || data == void 0) {
    return "";
  }
  if (typeof data === "string") {
    return data;
  }
  if (typeof data === "object") {
    return JSON.stringify(data);
  }
  return data.toString();
};
const hash = (type, data) => crypto.createHash(type).update(stringify(data)).digest("hex");
const log = {
  INFO: (content) => console.log(`${(/* @__PURE__ */ new Date()).toLocaleString()} - [INFO] - ${content}`),
  WARN: (content) => console.trace(`${(/* @__PURE__ */ new Date()).toLocaleString()} - [WARN] - ${content}`),
  DEBUG: (content) => console.log(`${(/* @__PURE__ */ new Date()).toLocaleString()} - [DEBUG] - ${content}`),
  CRITICAL: (content) => console.log(`${(/* @__PURE__ */ new Date()).toLocaleString()} - [CRITICAL] - ${content}`)
};
const draw = () => Math.floor(Math.random() * 100 + 1);
const chooseRandom = (list) => list[Math.floor(Math.random() * list.length)];
const randomNumberBetween = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);
const happensWithAChanceOf = (percentageChance) => draw() <= percentageChance ? true : false;
const randomizeWithinBounds = (list) => {
  const allChances = getRandomBounds(list);
  const random = randomNumberBetween(0, 100);
  const chosen = allChances.find(
    (item) => item.randomBounds[0] <= random && item.randomBounds[1] >= random
  );
  return chosen;
};
const drawSeeded = (seed) => {
  const seededRand = seedrandom(String(seed));
  return Math.floor(seededRand() * 100 + 1);
};
const chooseRandomSeeded = (list, seed) => {
  const seededRand = seedrandom(String(seed));
  return list[Math.floor(seededRand() * list.length)];
};
const happensWithAChanceOfSeeded = (percentageChance, seed) => drawSeeded(seed) <= percentageChance ? true : false;
const randomNumberBetweenSeeded = (min, max, seed) => {
  const seededRand = seedrandom(String(seed));
  return Math.floor(seededRand() * (max - min + 1) + min);
};
const randomizeWithinBoundsSeeded = (list, seed) => {
  const allChances = getRandomBounds(list);
  const random = randomNumberBetweenSeeded(0, 100, seed);
  const chosen = allChances.find(
    (item) => item.randomBounds[0] <= random && item.randomBounds[1] >= random
  );
  return chosen;
};
const getRandomBounds = (list) => {
  const chanceBounds = list.map((item, index) => {
    const prevChances = index === 0 ? 0 : list.slice(0, index).reduce((acc, item2) => acc + item2.chance, 0);
    const randomBounds = [
      prevChances === 0 ? 0 : prevChances + 1,
      item.chance + prevChances
    ];
    return { ...item, randomBounds };
  });
  return chanceBounds;
};
export {
  chooseRandom,
  chooseRandomSeeded,
  draw,
  drawSeeded,
  getRandomBounds,
  happensWithAChanceOf,
  happensWithAChanceOfSeeded,
  hash,
  log,
  randomNumberBetween,
  randomNumberBetweenSeeded,
  randomizeWithinBounds,
  randomizeWithinBoundsSeeded
};
